export default defineNuxtRouteMiddleware((to, from) => {
  if (!to.path.endsWith('/') && !to.path.includes('.')) {
    const queryParams = new URLSearchParams(to.query).toString();
    const newPath = `${to.path}/` + (queryParams ? `?${queryParams}` : '');
    return navigateTo(newPath, { redirectCode: 301 });
  }
});